var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMultiselectSendIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_160513",
    "data-name": "Group 160513",
    transform: "translate(-424 -104)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1912",
    "data-name": "Rectangle 1912",
    width: 16,
    height: 16,
    transform: "translate(424 104)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_395",
    "data-name": "Rectangle 395",
    width: 10,
    height: 10,
    transform: "translate(427 107)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1165",
    "data-name": "Group 1165",
    transform: "translate(427.282 108.089)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1204",
    "data-name": "Group 1204",
    transform: "translate(-0.282 -0.282)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_396",
    "data-name": "Rectangle 396",
    width: 8,
    height: 8,
    transform: "translate(0.597 0.597)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "send"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_58",
    "data-name": "Line 58",
    x1: 4.351,
    y2: 4.351,
    transform: "translate(4.162 0.681)",
    fill: "none",
    stroke: "#0032c5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_383",
    "data-name": "Path 383",
    d: "M11.193,2,7.976,11.193,6.137,7.056,2,5.218Z",
    transform: "translate(-2 -2)",
    fill: "none",
    stroke: "#0032c5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiselectSendIcon);
export default __webpack_public_path__ + "static/media/MultiselectSend-icon.77b620f110e4e5e2cc2faf219208ee9f.svg";
export { ForwardRef as ReactComponent };